// address.list.service.js
"use strict";

class addressListService {
  constructor($http, $q) {
    this.$http = $http;
    this.$q = $q;
    this.url = {
      services: '/api/customer/services'
    };
    this.defer = {
      gettingAddresses: undefined,
      gettingSelectedAddress: undefined,
      settingSelectedAddressId: undefined
    };

    this.servicesCached = null;
  }

  logAddressError(scope, error, extra = {}) {
    console.error("[addressListService] " + scope, {
      error,
      extra,
      state: {
        hasCachedServices: !!this.servicesCached,
        hasAddresses: !!this.addresses,
        hasSelectedAddress: !!this.selectedAddress,
        hasGettingAddressesDeferred: !!this.defer.gettingAddresses,
        hasGettingSelectedAddressDeferred: !!this.defer.gettingSelectedAddress,
        hasSettingSelectedAddressIdDeferred: !!this.defer.settingSelectedAddressId
      }
    });
  }

  getAddresses() {
    if (this.defer.gettingAddresses) {
      return this.defer.gettingAddresses.promise;
    }

    this.defer.gettingAddresses = this.$q.defer();

    //verifica si los datos están en caché
    if (this.servicesCached) {
      //si hay datos en caché, resuelve la promise sin atacar el endpoint
      this.addresses = this.getFormattedAddresses(this.servicesCached);
      this.defer.gettingAddresses.resolve(this.addresses);
    } else if (this.addresses) {
      //si no hay datos en caché pero existen en this.addresses resuelve la promise
      this.defer.gettingAddresses.resolve(this.addresses);
    } else {
      //si no hay datos en caché ni en this.addresses, consulta el endpoint
      this.$http
        .get(this.url.services)
        .then(data => {
          //almacena los datos obtenidos en caché
          this.servicesCached = data.data;
          //Primero agrupo los contratos en direcciones para que no salgan direcciones duplicadas
          this.grupoDirecciones = this.agruparContratosPorCodigoDual(this.servicesCached);
          //Y ahora filtro y formateo las direcciones
          this.addresses = this.getFormattedAddresses(this.grupoDirecciones);
          //this.addresses = this.getFormattedAddresses(this.servicesCached);

          this.defer.gettingAddresses.resolve(this.addresses);
        })
        .catch((error) => {
          this.logAddressError("getAddresses", error, { url: this.url.services });
          this.defer.gettingAddresses.reject(error);
        });
    }

    return this.defer.gettingAddresses.promise;
  }

  agruparContratosPorCodigoDual(data) {
    const grupos = {};
    let unicoCounter = 0; // contador para grupos únicos (sin codigo_dual)
    const gruposConConsumo = new Set();

    data.forEach(supply => {
      supply.contracts?.forEach(contract => {
        const codigo = contract.codigo_dual;

        const tieneCodigoValido =
          codigo !== null &&
          codigo !== undefined &&
          typeof codigo === "string" &&
          codigo.trim() !== "";

        // Clave de grupo
        const key = tieneCodigoValido
          ? codigo.trim()
          : `UNICO_${++unicoCounter}`; // cada contrato sin codigo_dual = grupo único

        // Crear grupo si no existe
        if (!grupos[key]) {
          grupos[key] = {
            id: null,
            id_gas: null,
            cups: null,
            cups_gas: null,
            codigo_dual: tieneCodigoValido ? codigo.trim() : null,
            address: null,
            cups_principal: null,
            tipo_contrato: null,
            contracts: []
          };
        }

        // Añadir contrato al grupo
        grupos[key].contracts.push(
          contract
        );

        // Solo LUZ: consumo (installation_type_id 1) prevalece sobre generación
        if (supply.type?.description === "LUZ") {
          const esConsumo = contract.installation_type_id == 1;
          if (!esConsumo && gruposConConsumo.has(key)) {
            return;
          }
          if (esConsumo) {
            gruposConConsumo.add(key);
          }
        }

        // Asignar campos
        if (tieneCodigoValido) {
          // Siempre buscar la direccion de LUZ del grupo
          if (supply.type?.description === "LUZ") {
            grupos[key].id = supply.id;
            grupos[key].cups = supply.cups;
            grupos[key].address = supply.address;
            grupos[key].cups_principal = supply.cups;
            grupos[key].tipo_contrato = "LUZ";
            grupos[key].contracts.forEach(supply_subitem => {
              if(supply_subitem.type.description==="GAS"){
                grupos[key].tipo_contrato = "LUZ Y GAS";
              }
            });
          }
          if (supply.type?.description === "GAS") {
            grupos[key].id_gas = supply.id;
            grupos[key].cups_gas = supply.cups;

            // Fallback: si no hay LUZ para este codigo_dual, usa direccion de GAS.
            if (!grupos[key].address && supply.address) {
              grupos[key].address = supply.address;
              grupos[key].id = grupos[key].id || supply.id;
              grupos[key].cups = grupos[key].cups || supply.cups;
              grupos[key].cups_principal = grupos[key].cups_principal || supply.cups;
              grupos[key].tipo_contrato = grupos[key].tipo_contrato || "GAS";
            }
          }
        } else {
          // Para direcciones no duales
          grupos[key].id = supply.id;
          grupos[key].id_gas = "";
          grupos[key].cups_gas = "";
          grupos[key].cups = supply.cups;
          grupos[key].address = supply.address;
          grupos[key].cups_principal = supply.cups;
          grupos[key].tipo_contrato = supply.type.description;
          if (supply.type?.description === "GAS") {
            grupos[key].id_gas = supply.id;
            grupos[key].cups_gas = supply.cups;
          }
        }
      });
    });

    return Object.values(grupos);
  }

  getFormattedAddresses(addresses) {
    let _addresses = [];
    addresses.forEach(address => {

      /* let contractsActive = [];
       if (address?.contracts?.length > 0) {
         contractsActive = address.contracts.filter(c => c.active);
       }*/
      let contractsActive = address?.contracts ?? [];

      //Filtramos en el listado superior de contratos para que no se muestren los contratos Cancelados
      let addContract = false;
      contractsActive.forEach(contract => {
        if(contract.contract_status_id !== 5 && contract.installation_type_id == 1){
          addContract = true;
        }
      });

      if(addContract){
        const addressData = address && address.address ? address.address : {};
        const unavailableText = "Dato no disponible aún";

        if (!address || !address.address) {
          this.logAddressError("getFormattedAddresses", undefined, {
            reason: "Direccion nula o ausente al formatear",
            addressId: address && address.id,
            tipoContrato: address && address.tipo_contrato
          });
        }

      _addresses.push({
        id: address.id,
        id_gas: address.id_gas,
        address: addressData.road || unavailableText,
        locality: addressData.locality || unavailableText,
        postalCode: addressData.postalcode || unavailableText,
        province: addressData.province || unavailableText,
        cadastral_reference: addressData.cadastral_reference || unavailableText,
        electricity:
          {
            supplyId: contractsActive.length > 0 ? contractsActive[0].id : undefined,
            monthlyInterval: true
          },
        gas: {},
        cups: address.cups,
        cups_gas: address.cups_gas,
        tipo_contrato: address.tipo_contrato,
        contracts: contractsActive
      });
      }
    })
    return _addresses;
  }

  setSelectedAddress(address) {
    this.selectedAddress = address;
    if (!this.defer.gettingSelectedAddress) {
      this.logAddressError("setSelectedAddress", undefined, {
        reason: "gettingSelectedAddress deferred no estaba inicializado",
        selectedAddressId: address && address.id
      });
      this.defer.gettingSelectedAddress = this.$q.defer();
    }
    this.defer.gettingSelectedAddress.resolve(this.selectedAddress);
    this.defer.gettingSelectedAddress = this.$q.defer();
    this.defer.gettingSelectedAddress.resolve(this.selectedAddress);
  }

  initializeSelectedAddress(addressId) {
    this.defer.settingSelectedAddressId = this.$q.defer();
    this.getAddresses().then(addresses => {
      this.setSelectedAddress(addresses.find(addr => addr.id == addressId))
      this.defer.settingSelectedAddressId.resolve();
      this.defer.settingSelectedAddressId = undefined;
    })
      .catch((error) => {
        this.logAddressError("initializeSelectedAddress", error, { addressId });
        this.defer.settingSelectedAddressId.reject(error);
         this.defer.settingSelectedAddressId = undefined;
      });
    return this.defer.settingSelectedAddressId.promise;
  }

  getSelectedAddress() {
    if (this.defer.gettingSelectedAddress) {
      return this.defer.gettingSelectedAddress.promise;
    }

    this.defer.gettingSelectedAddress = this.$q.defer();
    if (this.selectedAddress) {
      this.defer.gettingSelectedAddress.resolve(this.selectedAddress);
    } else if (this.defer.settingSelectedAddressId) {
      this.defer.settingSelectedAddressId.promise.then(() => this.defer.gettingSelectedAddress.resolve(this.selectedAddress));
    } else {
      this.getAddresses()
        .then(addressess => {
          if (this.defer.settingSelectedAddressId) {
            this.defer.settingSelectedAddressId.promise.then(() => this.defer.gettingSelectedAddress.resolve(this.selectedAddress));
            return;
          }
          if (!addressess || !addressess.length) {
            this.logAddressError("getSelectedAddress", undefined, {
              reason: "No hay direcciones disponibles para seleccionar",
              addressesLength: addressess && addressess.length
            });
          }
          this.setSelectedAddress(addressess[0]);
          this.defer.gettingSelectedAddress.resolve(this.selectedAddress);
        })
        .catch((error) => {
          this.logAddressError("getSelectedAddress", error);
          this.defer.gettingSelectedAddress.reject(error);
        });
     }

     return this.defer.gettingSelectedAddress.promise;

  }

  getBCProducts() {
    if (this.defer.gettingBC) {
      return this.defer.gettingBC.promise;
    }

    this.defer.gettingBC = this.$q.defer();

    //verifica si los datos están en caché
    if (this.servicesCached) {
      //console.log("inicio 0");
      //si hay datos en caché, procesa y resuelve la promesa
      var bc_product_list = [];
      this.servicesCached.forEach(function (dato) {
        dato["contracts"].forEach(function (contrato) {
          if (contrato["active"]) {
            bc_product_list.push(contrato["bill_classification"]);
          }
        });
      });

      this.bc_list = bc_product_list;
      //console.log("bc_list");
      //console.log(this.bc_list);
      this.defer.gettingBC.resolve(this.bc_list);
    } else if (this.bc_list) {
      //console.log("inicio 1");
      //si no hay datos en caché pero existen en this.bc_list resuelve la promesa
      this.defer.gettingBC.resolve(this.bc_list);
    } else {
      //console.log("inicio 2");
      //si no hay datos en caché ni en this.bc_list, consulta el endpoint
      this.$http
        .get(this.url.services)
        .then(data => {
          //almacena los datos obtenidos en caché
          this.servicesCached = data.data;

          var bc_product_list = [];
          this.servicesCached.forEach(function (dato) {
            dato["contracts"].forEach(function (contrato) {
              if (contrato["active"]) {
                bc_product_list.push(contrato["bill_classification"]);
              }
            });
          });
          this.bc_list = bc_product_list;
          this.defer.gettingBC.resolve(this.bc_list);
        })
        .catch(() => {
          this.defer.gettingBC.reject();
        });
    }

    return this.defer.gettingBC.promise;
  }

}

addressListService.$inject = ["$http", "$q"];

export {addressListService as ADDRESS_LIST_SERVICE};
